import { render, staticRenderFns } from "./CustomersWiseProductSalePrintReport.vue?vue&type=template&id=2ec1b4f0&scoped=true&"
import script from "./CustomersWiseProductSalePrintReport.vue?vue&type=script&lang=js&"
export * from "./CustomersWiseProductSalePrintReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomersWiseProductSalePrintReport.vue?vue&type=style&index=0&id=2ec1b4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1b4f0",
  null
  
)

export default component.exports